import React from 'react';
import { CheckCircle2Icon, LockKeyholeIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
const heroImage = 'https://cdn.magicpatterns.com/uploads/7pU87RMR1ZCPWVUzciwnit/Diseno-sin-titulo-_43_.webp';
export function HeroSection() {
  return <section className="bg-[#0A0A0A] px-5 py-6 sm:py-16" data-id="element-92">
      <div className="mx-auto grid max-w-6xl items-center gap-10 lg:grid-cols-[1.05fr_.95fr] lg:gap-14" data-id="element-93">
        <div className="text-center lg:text-left" data-id="element-94">
          <p className="mb-3 inline-flex items-center gap-2 rounded-full border border-[#d4af37]/40 bg-[#d4af37]/10 px-3 py-1.5 text-[9px] font-bold uppercase tracking-[.14em] text-[#d4af37] sm:mb-5 sm:px-4 sm:py-2 sm:text-[11px]" data-id="element-95">
            <span className="h-1.5 w-1.5 rounded-full bg-[#d4af37] sm:h-2 sm:w-2" data-id="element-96" />
            The #1 planning system for rugby coaches
          </p>
          <h1 className="font-display text-4xl font-bold uppercase leading-[.91] tracking-tight text-white sm:text-6xl md:text-7xl" data-id="element-97">
            Plan your entire rugby season{' '}
            <span className="text-[#d4af37]" data-id="element-98">in under 5 minutes.</span>
          </h1>

          <div className="relative mx-auto mt-3 w-full max-w-[310px] lg:hidden" data-id="element-99">
            <div className="absolute inset-4 rounded-full border border-[#d4af37]/25" aria-hidden="true" data-id="element-100" />
            <img src={heroImage} alt="Rugby Ready 6-in-1 coaching box set" width={1080} height={728} fetchPriority="high" className="relative z-10 w-[108%] max-w-none -translate-x-[4%] object-contain drop-shadow-2xl" data-id="element-101" />
          </div>

          <p className="mx-auto mt-4 max-w-xl text-sm font-medium leading-relaxed text-[#B0B0C0] lg:mx-0 lg:mt-6 lg:text-base sm:text-lg" data-id="element-102">
            Your complete 6-in-1 rugby coaching system: 365 days of sessions,
            progressions, set pieces, kicking and physical prep.
          </p>
          <ul className="mx-auto mt-4 flex max-w-xl flex-wrap justify-center gap-x-5 gap-y-2 text-sm font-semibold text-white lg:mx-0 lg:mt-6 lg:justify-start" data-id="element-103">
            {['1 Main Box Set', '5 Bonuses', '365 Days of Sessions', '6 Modules', 'All Age Groups'].map(item => <li key={item} className="flex items-center gap-1.5" data-id="element-104">
                <CheckCircle2Icon className="h-4 w-4 text-[#d4af37]" data-id="element-105" />
                {item}
              </li>)}
          </ul>
          <a href="#offer-details" className="cta-button mt-5 inline-flex w-full items-center justify-center rounded-2xl px-6 py-6 text-xl font-bold sm:text-2xl lg:mt-8 lg:w-auto" data-id="element-106">
            GET RUGBY READY NOW
          </a>
          <div className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-[#B0B0C0] lg:mt-6 lg:justify-start" data-id="element-107">
            <span className="flex items-center gap-1.5" data-id="element-108">
              <LockKeyholeIcon className="h-4 w-4 text-[#d4af37]" data-id="element-109" />
              Secure payment
            </span>
            <span className="flex items-center gap-1.5" data-id="element-110">
              <ZapIcon className="h-4 w-4 text-[#d4af37]" data-id="element-111" />
              Instant access
            </span>
            <span className="flex items-center gap-1.5" data-id="element-112">
              <ShieldCheckIcon className="h-4 w-4 text-[#d4af37]" data-id="element-113" />
              7-day guarantee
            </span>
          </div>
        </div>

        <div className="relative mx-auto hidden w-[115%] max-w-none lg:block" data-id="element-114">
          <div className="absolute inset-8 rounded-full border border-[#d4af37]/25" aria-hidden="true" data-id="element-115" />
          <img src={heroImage} alt="Rugby Ready 6-in-1 coaching box set" width={1080} height={728} fetchPriority="high" className="relative z-10 w-full object-contain drop-shadow-2xl" data-id="element-116" />
          <p className="relative z-10 mx-auto -mt-4 w-fit border border-[#d4af37]/30 bg-[#16161F] px-4 py-2 text-center text-xs font-bold uppercase tracking-widest text-[#d4af37]" data-id="element-117">
            Built for coaches who want structure
          </p>
        </div>
      </div>
    </section>;
}